// extracted by mini-css-extract-plugin
export default {"container":"section_container__1QNqL","inner":"section_inner__HB7tE","isContainer":"section_isContainer__3G-ho"};